import { render } from "./ReassignLeaveRequestModal.vue?vue&type=template&id=f2f9b118"
import script from "./ReassignLeaveRequestModal.vue?vue&type=script&lang=js"
export * from "./ReassignLeaveRequestModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__